import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';
import { companyInfo } from '../data/mock';
import { useLanguage } from '../context/languagecontext';

export const Footer = () => {
  const { t } = useLanguage();
  
  return (
    <footer className="bg-slate-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="mb-4">
              <span className="font-heading text-2xl font-black tracking-tighter text-white">
                SOUTH <span className="text-orange-500">PALMYRA</span>
              </span>
            </div>
            <p className="text-sm text-gray-400 mb-4">{t('footer.description')}</p>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">{t('footer.quickLinks')}</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm hover:text-orange-500 transition-colors">{t('nav.home')}</Link></li>
              <li><Link to="/services" className="text-sm hover:text-orange-500 transition-colors">{t('nav.services')}</Link></li>
              <li><Link to="/gallery" className="text-sm hover:text-orange-500 transition-colors">{t('nav.gallery')}</Link></li>
              <li><Link to="/about" className="text-sm hover:text-orange-500 transition-colors">{t('nav.about')}</Link></li>
              <li><Link to="/contact" className="text-sm hover:text-orange-500 transition-colors">{t('nav.contact')}</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">{t('footer.ourServices')}</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>{t('footer.service1')}</li>
              <li>{t('footer.service2')}</li>
              <li>{t('footer.service3')}</li>
              <li>{t('footer.service4')}</li>
              <li>{t('footer.service5')}</li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">{t('footer.contactUs')}</h3>
            <div className="space-y-3">
              <a href={`tel:${companyInfo.phone}`} className="flex items-center space-x-2 text-sm hover:text-orange-500 transition-colors">
                <Phone className="w-4 h-4 flex-shrink-0" /><span>{companyInfo.phone}</span>
              </a>
              <a href={`tel:${companyInfo.phoneSecondary}`} className="flex items-center space-x-2 text-sm hover:text-orange-500 transition-colors">
                <Phone className="w-4 h-4 flex-shrink-0" /><span>{companyInfo.phoneSecondary}</span>
              </a>
              <a href={`mailto:${companyInfo.email}`} className="flex items-center space-x-2 text-sm hover:text-orange-500 transition-colors">
                <Mail className="w-4 h-4 flex-shrink-0" /><span>{companyInfo.email}</span>
              </a>
              <div className="flex items-start space-x-2 text-sm">
                <MapPin className="w-4 h-4 flex-shrink-0 mt-1" /><span>{companyInfo.serviceArea}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-8 pt-8 text-center">
          <p className="text-sm text-gray-400">© {new Date().getFullYear()} {companyInfo.name}. {t('footer.allRights')}</p>
        </div>
      </div>
    </footer>
  );
};
